module.exports = __webpack_public_path__ + "img/training_mix4.8de63b65.jpg";